import { TicketCard } from "./TicketCard";
import type { Ticket } from "../../services/ticketsService";

interface TicketListProps {
  tickets: Ticket[];
  loading: boolean;
  showReporter?: boolean;
  emptyMessage: string;
  onSelect: (ticketId: string) => void;
}

export function TicketList({ tickets, loading, showReporter, emptyMessage, onSelect }: TicketListProps) {
  if (loading) {
    return <div className="text-muted-foreground animate-pulse py-8 text-center">Cargando tickets...</div>;
  }

  if (tickets.length === 0) {
    return <div className="text-muted-foreground py-8 text-center">{emptyMessage}</div>;
  }

  return (
    <div className="space-y-2">
      {tickets.map((ticket) => (
        <TicketCard
          key={ticket.id}
          ticket={ticket}
          showReporter={showReporter}
          onClick={() => onSelect(ticket.id)}
        />
      ))}
    </div>
  );
}
